export default {
  NAME: 'Nome',
  SURNAME: 'Cognome',
  EMAIL: 'Email',
  MESSAGE: 'Messaggio',
  PRIVACY: 'Accetta la <a href="https://www.iubenda.com/privacy-policy/87019403" target="_blank" rel="noopener"><bdi>Privacy</bdi></a>',
  SUBMIT: 'Invia messaggio',
  SENDING: 'Inviando',
  SENT: 'Inviato',

  TXTLINE1: 'Grazie',
  TXTLINE2: 'per averci contattato',
  TXTLINE3: 'ti risponderemo quanto prima.',

  ABOUT: 'Siamo',
  INVESTIMENTI: 'Investimenti',
  TEAM: 'Team',
  CONTATTI: 'Contatti',

  FORM_THX: 'Messaggio inviato, grazie per averci contattato.',

  LABEL1: 'Anno di investimento',
  LABEL2: 'Quota',
  LABEL3: 'Altri investitori',

  COOKIE_TEXT: 'Utilizzando questo sito web, accetti il nostro utilizzo dei <a href="https://www.iubenda.com/privacy-policy/87019403/cookie-policy" target="_blank" rel="noopener"><bdi>cookie</bdi></a>. Utilizziamo i cookie per offrirti una grande esperienza. ',
  COOKIE_BTN: 'Accetto',

  ERROR_TITLE: 'Aiutatemi!',
  VIDEO_VOLUME: 'Premi per ascoltare',
  VIDEO_MUTE: 'Premi per mutare',
  GO_BACK: 'Torna alla home',

  MENU_POLICY: '<a href="https://www.iubenda.com/privacy-policy/87019403" target="_blank" rel="noopener" aria-label="Privacy"><bdi>Privacy</bdi></a>',
  MENU_COOKIE: '<a href="https://www.iubenda.com/privacy-policy/87019403/cookie-policy" target="_blank" rel="noopener" aria-label"Cookie"><bdi>Cookie</bdi></a>',
};
